import Icon from '@/components/snippets/icon/icon'
import { formatPriceRangeLabel, isPriceFilterField, RANGE_INDICATOR } from './FilterUtils'
import { isSizeFilter, formatUniversalSizeValue } from './SizeFilterUtils'

export function FilterSelected({ activeFilters, onRemove, onClear }) {
  if (!activeFilters || activeFilters.size === 0) return null

  const formatFilterValue = (filter) => {
    const parts = filter.split(':')
    const field = parts[0]
    // Rejoin the tail: a value may legitimately contain a colon.
    const value = parts.slice(1).join(':')

    if (isPriceFilterField(field)) {
      const [min, max] = value.split(RANGE_INDICATOR)
      return formatPriceRangeLabel(min, max)
    }

    if (isSizeFilter(field, value)) {
      return formatUniversalSizeValue(value).replaceAll(RANGE_INDICATOR, '↔')
    }

    return value.replaceAll(RANGE_INDICATOR, '↔')
  }

  return (
    <div class="flex flex-col items-start lg:flex-row flex-wrap gap-0.5 lg:gap-x-0.75 lg:gap-y-0.875 lg-max:px-margin lg-max:py-0.75 lg-max:border-b lg-max:border-borders-default">
      <div class="flex flex-row flex-wrap gap-0.5 items-start lg:items-center justify-start">
      {[...activeFilters].map((filter) => {
        return (
          <button class="shrink-0 btn btn-accent btn-fill btn-s text-xs font-medium gap-x-0.5" onClick={() => onRemove(filter)} aria-label={`Remove ${formatFilterValue(filter)} filter`}>
            <span className="text-type-black-primary text-2xs normal-case">
              {formatFilterValue(filter)}
            </span>
            <div className="flex size-[14px] children:size-full">
              <Icon id="close" />
            </div>
          </button>
        )
      })}
      </div>
      <button class="shrink-0 btn btn-accent btn-text btn-s text-xs text-type-black-tertiary link-under-line py-0.75" onClick={onClear} aria-label="Clear all filters">
        <span className="text-type-black-tertiary text-2xs normal-case">
          Clear all
        </span>
      </button>
    </div>
  )
}
